/** @jsx jsx */

import { FC, ReactNode } from 'react';

import { css, jsx } from '@emotion/core';

import { N90 } from '@atlaskit/theme/colors';

import { IconData } from '../types';

import IconCell from './icon-cell';

const gridStyles = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
  gap: '16px',
});

/**
 * __Grid__
 *
 * Grid component
 */
const Grid: FC<ReactNode> = ({ children }) => {
  return <div css={gridStyles}>{children}</div>;
};

type GridSectionProps = {
  importPath: string;
  heading: string;
  icons?: IconData[];
  testId?: string;
};

const headerStyles = css({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '12px',
});

const importStyles = css({
  color: N90,
  marginLeft: '8px',
});

const sectionStyles = css({
  marginBottom: '48px',
});

const formatTitle = (title: string) => {
  let formatted = title.replace('-', ' '); // replace the hyphen in media-services with a space
  formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
  return formatted;
};

/**
 * __Grid section__
 *
 * Component for a grid 'section'.
 * The Icon Explorer is made up of several grids separated by headings.
 * This grid section component consists of the grid as well as the heading for the section.
 *
 */
const GridSection = ({
  importPath,
  heading,
  icons,
  testId,
}: GridSectionProps) => {
  return icons ? (
    <div css={sectionStyles} data-testid={testId}>
      <div css={headerStyles}>
        <h3>{formatTitle(heading)}</h3>
        <span css={importStyles}>{importPath}</span>
      </div>
      <Grid>
        {icons.map(icon => (
          <IconCell {...icon} key={icon.componentName} />
        ))}
      </Grid>
    </div>
  ) : null;
};

export default GridSection;
